var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 d-flex align-items-center"},[_c('p',{staticClass:"subtitle-17 mb-0"},[_vm._v(_vm._s(_vm.$t(_vm.subtitle)))])]),_c('div',{staticClass:"col-md-6"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }